<template>
  <v-col
    cols="12"
    lg="4"
  >
    <div class="boxes-parent">
      <div
        v-for="(card, index) in AsideCardData"
        :key="index"
      >
        <div class="aside-box">
          <percentage-box :box-data="card">
            <template #icon>
              <component :is="card.icon" />
            </template>
          </percentage-box>
          <circle-progress-bar
            :key="index"
            class="progress-bar"
            :progress-bar-data="card.progressBar"
            :size="85"
            :width="6"
          />
        </div>
        <div
          v-if="index !== AsideCardData.length - 1"
          class="line"
        />
      </div>
    </div>
  </v-col>
</template>

<script>
  import { mapState } from 'pinia';

  import PercentageBox from '@/components/SharedComponents/Boxes/PercentageBox.vue';
  import CircleProgressBar from '@/components/SharedComponents/Charts/CircleProgressBar.vue';
  import AbandonedCallsIcon from '@/components/SharedComponents/Icon/AbandonedCalls.vue';
  import AnsweredCallsIcon from '@/components/SharedComponents/Icon/AnsweredCalls.vue';
  import UnansweredCallsIcon from '@/components/SharedComponents/Icon/UnansweredCalls.vue';
  import { useDashboardStore } from '@/stores/reports/dashboard.store';
  import { formatPercentage } from '@/utilities';

  export default {
    components: {
      PercentageBox,
      AbandonedCallsIcon,
      AnsweredCallsIcon,
      UnansweredCallsIcon,
      CircleProgressBar,
    },
    computed: {
      ...mapState(useDashboardStore, ['summaryTotals']),
      AsideCardData() {
        const { abandoned, answered, missed, total } = this.summaryTotals;
        const options = { decimalPlaces: 1, baseValue: total, withoutPercent: true };

        // read CSS vars
        const rootStyles = getComputedStyle(document.documentElement);

        return [
          {
            title: this.$t('dashboard.abandoned_calls'),
            value: abandoned || 0,
            color: 'orange50',
            progressBar: {
              color: '#f7c54e',
              percentage: formatPercentage(abandoned, options) || 0,
            },
            icon: 'AbandonedCallsIcon',
          },
          {
            title: this.$t('dashboard.answered_calls'),
            value: answered || 0,
            color: 'success50',
            progressBar: {
              color: rootStyles.getPropertyValue('--color-base-500').trim(),
              percentage: formatPercentage(answered, options) || 0,
            },
            icon: 'AnsweredCallsIcon',
          },
          {
            title: this.$t('dashboard.unanswered_calls'),
            value: missed || 0,
            color: 'error50',
            progressBar: {
              color: '#ff4f45',
              percentage: formatPercentage(missed, options) || 0,
            },
            icon: 'UnansweredCallsIcon',
          },
        ];
      },
    },
  };
</script>

<style lang="scss" scoped>
  .boxes-parent {
    order: 2;
    height: 353px;
    overflow: hidden;
    width: 100%;
    border-radius: 8px;
    border: 1px solid var(--gray100);
    background-color: var(--shadesWhite);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px;
    // gap: 16px;

    @include responsive(max, 1279.5px) {
      flex-direction: row;
      height: fit-content;
      justify-content: unset;
      gap: 12.5rem;
    }

    @include responsive(max, 768px) {
      padding: 8px;
      border-radius: 12px;
      justify-content: space-between;
      gap: 0;
    }

    .aside-box {
      height: fit-content;
      display: flex;
      justify-content: space-between;
      align-items: center;

      svg {
        @include responsive(max, 768px) {
          height: 16px;
          width: 16px;
        }
      }
    }

    .line {
      width: 100%;
      height: 1px;
      margin: 1rem 0;
      background-color: var(--gray100);

      @include responsive(max, 1279.5px) {
        display: none;
      }

      @include responsive(max, 768px) {
        display: none;
      }
    }
    .progress-bar {
      @include responsive(max, 1279.5px) {
        display: none;
      }

      @include responsive(max, 768px) {
        display: none;
      }
    }
  }
</style>
